"use client";
import { useState, useEffect } from "react";

const EXPIRATION_DAYS = 1;

export function useCookiesAccepted() {
  const [cookiesAccepted, setCookiesAccepted] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const getCookiesStatus = () => {
      if (typeof window !== "undefined") {
        const isAccepted = localStorage.getItem("cookiesAccepted");
        const acceptedDate = localStorage.getItem("cookiesAcceptedDate");

        if (isAccepted === "false" && acceptedDate) {
          const savedDate = new Date(acceptedDate);
          const currentDate = new Date();

          const diffInDays =
            (currentDate.getTime() - savedDate.getTime()) / (1000 * 60 * 60 * 24);

          if (diffInDays > EXPIRATION_DAYS) {
            localStorage.removeItem("cookiesAccepted");
            localStorage.removeItem("cookiesAcceptedDate");
            setCookiesAccepted(undefined);
          } else {
            setCookiesAccepted(false);
          }
        } else if (isAccepted === "true") {
          setCookiesAccepted(true);
        } else {
          setCookiesAccepted(undefined);
        }
      }
    };

    getCookiesStatus();

    const handleStorageChange = () => {
      getCookiesStatus();
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const updateCookiesAccepted = (accepted: boolean) => {
    if (typeof window !== "undefined") {
      localStorage.setItem("cookiesAccepted", accepted ? "true" : "false");
      localStorage.setItem("cookiesAcceptedDate", new Date().toISOString());
      setCookiesAccepted(accepted);
      window.dispatchEvent(new Event("storage"));
    }
  };

  return { cookiesAccepted, setCookiesAccepted: updateCookiesAccepted };
}
